import * as THREE from 'three';
import { STLLoader } from 'three/addons/loaders/STLLoader.js';


function STLViewer(container, stlFile, envMap = null, isPolished = false) {
    console.log("STLViewer called with container:", container, "and stlFile:", stlFile);

    var camera = new THREE.PerspectiveCamera(35, container.clientWidth / container.clientHeight, 0.1);
    camera.position.set(0, 0, 3);

    var scene = new THREE.Scene();

    // Add background to scene
    var backgroundColor = new THREE.Color("#000000");
    scene.background = backgroundColor;

    

    // Add environment map for reflections from three js examples
    try {
        if (envMap) {
            var path = envMap;
            var format = '.jpg';
            var urls = [
                path + 'posx' + format, path + 'negx' + format,
                path + 'posy' + format, path + 'negy' + format,
                path + 'posz' + format, path + 'negz' + format
            ];

            var reflectionCube = new THREE.CubeTextureLoader().load(urls);
            scene.environment = reflectionCube; // Set the environment for reflections
            
            // scene.background = reflectionCube; // Use the same cube texture as the background
        }
    } catch (error) {
        console.log("Error loading environment map:", error);
    }


    // Directional light to illuminate the model
    var light = new THREE.DirectionalLight("#ffffff", 20);
    light.position.set(0.2, 0.2, 3);
    scene.add(light);

    var spotLight = new THREE.SpotLight(0xffffff, 10);
    spotLight.position.set(-1, -1, -1);
    spotLight.angle = Math.PI / 6;
    spotLight.distance = 5.5;
    spotLight.castShadow = true;
    scene.add(spotLight);

    var backLight = new THREE.DirectionalLight("#ffffff", 10);
    backLight.position.set(-0.5, -0.5, -1);
    scene.add(backLight);

    // Ambient light to soften shadows
    var ambientLight = new THREE.AmbientLight(0x404040, 5); // Soft white light
    scene.add(ambientLight);


    // Transparent diamond-like material
    var material = new THREE.MeshPhysicalMaterial({
        color: 0xffffff,
        metalness: 0,
        roughness: isPolished ? 0.05 : 0.1, // Lower roughness for a more polished look
        reflectivity: isPolished ? 0.9 : 0.5, // High reflectivity for a diamond-like appearance
        // dispersion: 0.2, // Simulate light dispersion for a more realistic diamond effect
        transmission: 1, // Fully transparent
        thickness: 3, // Thickness of the material for refraction
        ior: 2.417, // Index of refraction for diamond
        // clearcoat: 1.0, // Add a clear coat layer for extra shine
        // clearcoatRoughness: 0.1, // Roughness of the clear coat layer
        side: THREE.DoubleSide, // Ensure both sides of the geometry are rendered
        opacity: 1.0, // Ensure the material is fully opaque (transmission will handle transparency)
        transparent: true, // Enable transparency
    });

    var debugMaterial = new THREE.MeshPhysicalMaterial({ color: 0xff0000, wireframe: true });

    // material = debugMaterial; // Use debug material for testing

    // Add a cube to center for reference
    const cubeSize = 1.2; // Size of the cube
    var cubeGeometry = new THREE.BoxGeometry(cubeSize, cubeSize, cubeSize);
    var cubeMaterial = debugMaterial;
    var cube = new THREE.Mesh(cubeGeometry, cubeMaterial);
    scene.add(cube);
    cube.visible = false; // Hide the cube, but keep it as a reference for centering the model

    camera.lookAt(cube.position);


    var loader = new STLLoader();
    loader.load(stlFile, async function (geometry) {

        console.log("STL file loaded successfully:", stlFile);
        console.log("Geometry:", geometry);

        const mesh = new THREE.Mesh(geometry, material);

        mesh.castShadow = true;
        mesh.receiveShadow = true;

        // Use smooth shading for a better appearance
        mesh.geometry.computeVertexNormals();

        if (isPolished){
            // For polished models rotate 90 degrees counterclockwise around X axis
            mesh.geometry.rotateX(Math.PI / 2);
            mesh.geometry.rotateZ(Math.PI/2); // Rotate 180 degrees around Z axis to correct orientation
            mesh.updateMatrixWorld(); // Update the world matrix after transformations
        }

        // scale mesh to fit within the cubeGeometry (0.2 x 0.2 x 0.2) while maintaining aspect ratio
        console.log("Original bounding box:", mesh.geometry.boundingBox);
        const boundingBox = new THREE.Box3().setFromObject(mesh);
        const size = new THREE.Vector3();
        boundingBox.getSize(size);
        const maxDimension = Math.max(size.x, size.y, size.z);

        console.log("Model size:", size, "Max dimension:", maxDimension);

        const scaleFactor = cubeSize / maxDimension; // Scale to fit within the cube
        console.log("Scale factor:", scaleFactor);
        mesh.scale.multiplyScalar(scaleFactor);


        // Recalculate normals after transformations
        mesh.geometry.computeVertexNormals();
        mesh.updateMatrixWorld(); // Update the world matrix after transformations

        // Move the mesh to the center of the cube
        const newBoundingBox = new THREE.Box3().setFromObject(mesh);
        const newCenter = new THREE.Vector3();
        newBoundingBox.getCenter(newCenter);
        mesh.position.sub(newCenter); // Center the mesh at the origin

        scene.add(mesh);

        camera.lookAt(mesh.position);

        // Update Lights to target the mesh
        light.target = mesh;
        light.updateMatrixWorld();

        spotLight.target = mesh;
        spotLight.updateMatrixWorld();

        backLight.target = mesh;
        backLight.updateMatrixWorld();

    }, function (xhr) {
        console.log((xhr.loaded / xhr.total * 100) + '% loaded');
    }, function (error) {
        console.error('An error happened while loading the STL file:', error);
    });

    var renderer = new THREE.WebGLRenderer({ antialias: true, alpha: false });
    renderer.setSize(container.clientWidth, container.clientHeight);
    container.appendChild(renderer.domElement);

    window.addEventListener('resize', function () {
        camera.aspect = container.clientWidth / container.clientHeight;
        camera.updateProjectionMatrix();
        renderer.setSize(container.clientWidth, container.clientHeight);
    }, false);

    // Render
    function animate() {

        let time = Date.now() * 0.001;

        scene.traverse(function (child) {
            if (child.isMesh) {
                child.rotation.y = time * 0.3; // Rotate around Y axis

                if (!isPolished) {
                    child.rotation.x = time * 0.1; // Slow rotation around X axis for rough scans
                }
                
            }
        });

        requestAnimationFrame(animate);
        renderer.render(scene, camera);
    }
    animate();

}



// get container with data attribute: data-stl
document.querySelectorAll('[data-stl]').forEach(container => {
    const stlFile = container.getAttribute('data-stl');
    const envMap = container.getAttribute('data-env-map');
    const isPolished = container.getAttribute('data-polished') === 'true';
    if (!stlFile) {
        console.error("No STL file specified for container:", container);
        return;
    } else {
        console.log("Found STL file:", stlFile, "for container:", container);
        STLViewer(container, stlFile, envMap, isPolished);
    }

});